import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCModalLimitRateComponent = class UiCModalLimitRateComponent {
    constructor(modalController) {
        this.modalController = modalController;
    }
    ngOnInit() {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.amountDailyLimit = this.response.amountDailyLimit;
        this.amountThirtyLimit = this.response.amountThirtyLimit;
        this.valueDailyLimit = this.response.valueDailyLimit;
        this.valueThirtyLimit = this.response.valueThirtyLimit;
    }
    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            dismissed: true,
        });
        const objNotification = [];
        objNotification.push(JSON.parse(localStorage.getItem('notifications')));
        localStorage.setItem('notifications', JSON.stringify({ notifications: false }));
    }
};
UiCModalLimitRateComponent.ctorParameters = () => [
    { type: ModalController }
];
__decorate([
    Input()
], UiCModalLimitRateComponent.prototype, "response", void 0);
UiCModalLimitRateComponent = __decorate([
    Component({
        selector: 'ui-c-modal-limit-rate',
        template: "<div class=\"ui-c-modal-limit-rate-inner d-flex flex-column justify-content-center align-items-center mt-3\">\n  <ion-row>\n    <ion-col size=\"12\" class=\"text-center\">\n      <h2 class=\"header-title font-size-18\">\n        {{ 'LIMITS_RATE.HEADER.ONE' | wlpTranslate }}\n      </h2>\n      <p class=\"lead-text font-size-18\">\n        {{ 'LIMITS_RATE.LEAD_TEXT.ONE' | wlpTranslate }}\n      </p>\n      <h2 class=\"header-title font-size-18\">{{ 'LIMITS_RATE.HEADER.TWO' | wlpTranslate }}</h2>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"content-values\">\n    <ion-col>\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"\n          ><strong>{{ 'LIMITS_RATE.LIMITS.VALUE_DAILY_LIMIT' | wlpTranslate }}</strong></ion-col\n        >\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ valueDailyLimit | currency: 'BRL' }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"\n          ><strong>{{ 'LIMITS_RATE.LIMITS.VALUE_THIRTY_LIMIT' | wlpTranslate }}</strong></ion-col\n        >\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ valueThirtyLimit | currency: 'BRL' }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"\n          ><strong>{{ 'LIMITS_RATE.LIMITS.AMOUNT_DAILY_LIMIT' | wlpTranslate }}</strong></ion-col\n        >\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ amountDailyLimit }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"\n          ><strong>{{ 'LIMITS_RATE.LIMITS.AMOUNT_THIRTY_LIMIT' | wlpTranslate }}</strong></ion-col\n        >\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ amountThirtyLimit }}</ion-col>\n      </ion-row>\n    </ion-col>\n  </ion-row>\n\n  <ion-row>\n    <ion-col size=\"12\" class=\"text-center\">\n      <p class=\"lead-text font-size-18\">\n        {{ 'LIMITS_RATE.LEAD_TEXT.TWO' | wlpTranslate }}\n      </p>\n    </ion-col>\n\n    <ion-col size=\"12\" class=\"text-center\">\n      <ion-button class=\"ion-button\" (click)=\"dismiss()\">\n        <ion-icon name=\"thumbs-up\" class=\"mr-2\"></ion-icon>\n        <ion-label class=\"mt-1\">{{ 'LIMITS_RATE.BUTTON' | wlpTranslate }}</ion-label>\n      </ion-button>\n    </ion-col>\n  </ion-row>\n</div>\n"
    })
], UiCModalLimitRateComponent);

let UiCModalLimitRateModule = class UiCModalLimitRateModule {
};
UiCModalLimitRateModule = __decorate([
    NgModule({
        declarations: [UiCModalLimitRateComponent],
        imports: [IonicModule, CommonModule, UiBsTranslateModule],
        exports: [UiCModalLimitRateComponent],
    })
], UiCModalLimitRateModule);

/*
 * Public API Surface of ui-c-modal-limit-rate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCModalLimitRateComponent, UiCModalLimitRateModule };
//# sourceMappingURL=wlp-ui-c-modal-limit-rate.js.map
